/* How It Works page. Generated by Claude/website-redesign/make_section.py. */
(() => {
if (!document.querySelector('.hiw')) return;
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const mobile = matchMedia('(max-width: 900px)');
const fmt = n => Math.round(n).toLocaleString('en-US');
const money = n => '$' + Math.round(n).toLocaleString('en-US');
const r100 = n => n >= 1000 ? Math.round(n / 100) * 100 : Math.round(n / 10) * 10;
// Chart colors match the NOWi console (STANDARD_COLORS.BLUE / RED); UI colors are the website brand.
const C = { navy:'#1C3F60', muted:'#615F5F', rule:'#E1E6F0', wash:'#F3F5FA', flow:'#1F8EF1', deep:'#0E39B8', leak:'#F44336' };
const svgNS = 'http://www.w3.org/2000/svg';
const DAY = 1440, RATE = 18 / 1000;

/* ---------- time helpers (UTC so there is no DST jump) ---------- */
const mins = (m, d, h = 0, mi = 0) => Math.round((Date.UTC(2026, m, d, h, mi) - Date.UTC(2026, 0, 1)) / 60000);
const dayOf = (m, d) => Math.round(mins(m, d) / DAY);
const LEAK = mins(2, 4, 2, 14), ALERT = LEAK + DAY, LEAK_END_DAY = dayOf(3, 30);
const DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], MON = ['Jan','Feb','Mar','Apr','May'], MONTH = ['January','February','March','April'];
const dt = i => new Date(Date.UTC(2026, 0, 1) + i * 60000);
const clock = d => { const h = d.getUTCHours(), m = d.getUTCMinutes(); return ((h + 11) % 12 + 1) + ':' + String(m).padStart(2, '0') + (h < 12 ? ' AM' : ' PM'); };
const stamp = i => { const d = dt(i); return DOW[d.getUTCDay()] + ' ' + MON[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + clock(d); };
const dlabel = d => { const x = dt(d * DAY); return DOW[x.getUTCDay()] + ' ' + MON[x.getUTCMonth()] + ' ' + x.getUTCDate(); };

/* ---------- property types ---------- */
const rnd = (i, k) => { let a = (Math.imul(i, 374761393) + Math.imul(k, 668265263)) | 0; a = Math.imul(a ^ (a >>> 13), 1274126177); a ^= a >>> 16; return (a >>> 0) / 4294967296; };
const g = (h, mu, s) => Math.exp(-((h - mu) ** 2) / (2 * s * s));
const ss = (a, b, x) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
const TYPES = {
  apartments: {
    meter: 'Building C main meter', alertName: 'Building C', subject: 'Maple Court, Building C', poss: "Building C's", the: 'the building', who: 'The property manager', quiet: 'overnight',
    s0h: 'Every building has a daily rhythm.',
    s0p: 'Use peaks in the morning and evening. Overnight, while everyone sleeps, it drops to zero.',
    cause: 'A toilet starts running in Building C.',
    explain: 'warmer weather, more move-ins, a pool refill, landscaping',
    leak0: 2, leak1: 4, dip: 0.095, spike: [1.5, 3],
    shape(h, wkend) { return 32 * g(h, wkend ? 8.6 : 7.3, 1.1) + 15 * g(h, 12.5, 2.2) + 25 * g(h, 19.4, 1.7) + 6 * ss(5.5, 7, h) * (1 - ss(22.5, 24, h)); },
    quietAt: h => h < 5 || h >= 23.5,
    est: { count: 'Apartment units', n: 240, per: 'Water use per unit per day', perN: 130, perHint: 'Gallons. 100 to 150 is typical for apartments.', share: 8.5, shareHint: '8.5% is what we measured at one of our published case-study properties. The worst portfolio we have seen was losing 28%.' },
  },
  restaurant: {
    meter: 'Restaurant main meter', alertName: 'Harbor Grill', subject: 'Harbor Grill', poss: "Harbor Grill's", the: 'the restaurant', who: 'The general manager', quiet: 'after-close',
    s0h: 'A restaurant runs on a schedule.',
    s0p: 'Use climbs from 7 AM and peaks with the dinner rush. Overnight it drops to a low floor, mostly ice machines.',
    floor: 0.14,
    cause: "The ice machine's fill valve sticks open.",
    explain: 'a busier month, longer hours, a new menu, more catering',
    leak0: 0.4, leak1: 1, dip: 0.09, spike: [0.4, 1.2],
    shape(h, wkend) { const P = [.4,.2,.3,.4,.5,.3,.3,.8,1.1,1,1.2,1.5,1.6,1.7,1.7,1.6,1.4,1.4,1.6,2.1,1.6,.6,.5,.4], a = Math.floor(h), f = h - a; return 3.2 * (P[a] * (1 - f) + P[(a + 1) % 24] * f) * (wkend ? 1.1 : 1); },
    quietAt: h => h < 6 || h >= 23.5,
    est: { count: 'Restaurant locations', n: 8, per: 'Water use per location per day', perN: 4600, perHint: 'Gallons. The restaurants we monitor average about 4,600. Quick-service sites run 800 to 1,400.', share: 5, shareHint: 'No data of your own yet? Start low. Even 5% adds up across locations.' },
  },
  office: {
    meter: 'Building main meter', alertName: '400 Park Plaza', subject: '400 Park Plaza', poss: "400 Park Plaza's", the: 'the building', who: 'The building engineer', quiet: 'overnight',
    s0h: 'An office runs on the workday.',
    s0p: 'Use follows the workday. Nights and weekends sit near zero.',
    cause: 'A urinal valve sticks open.',
    explain: 'more people back in the office, warmer weather on the cooling system, a new tenant',
    leak0: 0.5, leak1: 1.2, dip: 0.115, spike: [0.4, 1.2],
    shape(h, wkend) { return wkend ? 0.6 * g(h, 12, 3) : 11 * ss(6.5, 8, h) * (1 - ss(17, 18.5, h)) + 6 * g(h, 12, 1); },
    quietAt: h => h < 5.5 || h >= 20,
    est: { count: 'Office buildings', n: 4, per: 'Water use per building per day', perN: 8000, perHint: 'Gallons. Take the monthly gallons from the water bill and divide by 30.', share: 5, shareHint: 'No data of your own yet? Start low. Even 5% adds up.' },
  },
  industrial: {
    meter: 'Plant 2 main meter', alertName: 'Plant 2', subject: 'Plant 2', poss: "Plant 2's", the: 'the plant', who: 'The facilities manager', quiet: 'between-shift',
    s0h: 'A plant runs in shifts.',
    s0p: 'Use follows the shifts. Between shifts the plant should go quiet, and that gap is where wasted water shows up.',
    cause: 'A wash-down valve is left open after second shift.',
    explain: 'higher production, a new line, hotter weather on the cooling towers',
    leak0: 3, leak1: 7, dip: 0.115, spike: [2, 6],
    shape(h, wkend) { return (wkend ? 0.15 : 1) * 55 * ss(5.5, 6.2, h) * (1 - ss(23, 23.6, h)) * (1 - 0.6 * g(h, 14.75, 0.25)); },
    quietAt: h => h < 5.5 || h >= 23.6,
    est: { count: 'Sites', n: 3, per: 'Water use per site per day', perN: 40000, perHint: 'Gallons. Take the monthly gallons from the water bill and divide by 30.', share: 5, shareHint: 'Between-shift waste and leaks often run higher. Start at 5% if you have no data.' },
  },
};
for (const t of Object.values(TYPES)) t.grow = Math.log(t.leak1 / t.leak0) / (LEAK_END_DAY - LEAK / DAY);
function model(t) {
  const leakAt = i => i < LEAK ? 0 : Math.min(t.leak1, t.leak0 * Math.exp(t.grow * (i - LEAK) / DAY));
  const useAt = i => {
    const day = Math.floor(i / DAY), h = (i - day * DAY) / 60, dow = ((day + 4) % 7 + 7) % 7, wkend = dow === 0 || dow === 6;
    let c = t.shape(h, wkend) * (0.93 + 0.14 * rnd(day, 7)) * (1 - t.dip * Math.min(1, Math.max(0, (day - 45) / 60)));
    let v = c * (0.6 + 0.8 * rnd(i, 1));
    if (t.quietAt(h)) { v = t.floor ? t.floor * (0.55 + 0.9 * rnd(i, 2)) : rnd(i, 2) < 0.6 ? 0 : t.spike[0] * 0.15 * rnd(i, 3); if (rnd(i, 4) < 0.025) v += t.spike[0] * (0.6 + 0.6 * rnd(i, 5)); }
    else if (rnd(i, 4) < 0.03) v += t.spike[0] + t.spike[1] * rnd(i, 5);
    return v;
  };
  const flow = i => useAt(i) + leakAt(i) * (1 + 0.04 * (rnd(i, 6) - 0.5));
  const daily = [], dailyLeak = [], nightMin = [];
  for (let d = 0; d < 130; d++) {
    let s = 0, l = 0, lo = Infinity;
    for (let k = 0; k < DAY; k++) { const i = d * DAY + k, v = flow(i); s += v; l += leakAt(i); if (k >= 60 && k < 300) lo = Math.min(lo, v); }
    daily.push(s); dailyLeak.push(l); nightMin.push(lo);
  }
  const leakGal = (a, b) => { let s = 0; for (let i = Math.max(a, LEAK); i < b; i++) s += leakAt(i); return s; };
  const base = daily.slice(dayOf(1, 1), dayOf(2, 1)).reduce((a, b) => a + b, 0) / 28;
  // Two months before the year starts, with the swings real bills have (holiday guests in December).
  const span = (a, b) => { let s = 0; for (let i = a * DAY; i < b * DAY; i++) s += useAt(i); return s; };
  const prior = [{ name: 'November', short: 'Nov', v: span(-61, -31) * 1.03 }, { name: 'December', short: 'Dec', v: span(-31, 0) * 1.08 }];
  return { t, leakAt, flow, daily, dailyLeak, nightMin, leakGal, base, prior };
}
const cache = {};
const getModel = k => cache[k] || (cache[k] = model(TYPES[k]));

/* ---------- chart helpers ---------- */
function nice(v) { const p = 10 ** Math.floor(Math.log10(v)), f = v / p; const n = [1, 2, 4, 5, 8, 10].find(x => x >= f - 1e-9); return n * p; }
function ticks(max) { const lead = Math.round(max / 10 ** Math.floor(Math.log10(max))); const k = lead === 5 ? 5 : 4; return Array.from({ length: k + 1 }, (_, i) => max * i / k); }
const tfmt = v => v >= 1000 ? (v / 1000).toLocaleString('en-US', { maximumFractionDigits: 1 }) + 'k' : String(+v.toFixed(2));
const lab = (tx, ty, t, col, anchor = 'start', wt = 500) => `<text x="${tx}" y="${ty}" font-size="12" font-weight="${wt}" fill="${col}" text-anchor="${anchor}" paint-order="stroke" stroke="#FFFFFF" stroke-width="4" stroke-linejoin="round">${t}</text>`;
const roundTop = (x0, y0, bw, top, r) => { r = Math.max(0, Math.min(r, bw / 2, (y0 - top) / 2)); return `M${x0} ${y0}V${top + r}q0 -${r} ${r} -${r}h${bw - 2 * r}q${r} 0 ${r} ${r}V${y0}Z`; };
function mount(el) { el.innerHTML = ''; const svg = document.createElementNS(svgNS, 'svg'), tip = document.createElement('div'); tip.className = 'tip'; tip.hidden = true; el.append(svg, tip); return { svg, tip }; }
function watch(el, draw) { let w = 0; new ResizeObserver(() => { if (el.clientWidth && el.clientWidth !== w) { w = el.clientWidth; draw(); } }).observe(el); }

/* ---------- flow chart: 15-minute averages in one smooth panel ---------- */
const BIN = 15;
function flowChart(el, o) {
  const { svg, tip } = mount(el);
  let M = null, avg = [], lka = [], ymax = 10, st = { until: o.to, leak: false, marker: false, alert: false, notes: false };
  function load(m) {
    M = m; avg = []; lka = [];
    for (let a = o.from; a < o.to; a += BIN) { let s = 0, l = 0; for (let i = a; i < a + BIN; i++) { s += M.flow(i); l += M.leakAt(i); } avg.push(s / BIN); lka.push(l / BIN); }
    ymax = Math.max(...avg) * 1.1;
  }
  function draw() {
    const w = el.clientWidth; if (!w || !M) return;
    const h = mobile.matches ? 240 : 300, m = { t: 30, r: 8, b: 24, l: 8 };
    const iw = w - m.l - m.r, ih = h - m.t - m.b, n = o.to - o.from, base = m.t + ih;
    const x = i => m.l + (i - o.from) / n * iw, y = v => base - v / ymax * ih;
    const nb = Math.min(avg.length, Math.ceil((Math.min(st.until, o.to) - o.from) / BIN));
    let s = '';
    for (let b = 0; b < avg.length; b++) { const i = o.from + b * BIN; if (M.t.quietAt((i % DAY) / 60)) s += `<rect x="${x(i)}" y="${m.t}" width="${x(i + BIN) - x(i) + 0.5}" height="${ih}" fill="${C.wash}"/>`; }
    if (nb > 0) {
      const pts = Array.from({ length: nb }, (_, b) => [x(o.from + b * BIN + BIN / 2), y(avg[b])]);
      const line = pts.map((p, k) => (k ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(''), xe = pts[nb - 1][0];
      s += `<path d="${line}L${xe} ${base}L${pts[0][0]} ${base}Z" fill="${C.flow}" fill-opacity=".85"/><path d="${line}" fill="none" stroke="${C.flow}" stroke-width="2" stroke-linejoin="round"/>`;
      const lb0 = Math.max(0, Math.floor((LEAK - o.from) / BIN));
      if (st.leak && lb0 < nb) {
        let lp = `M${x(Math.max(LEAK, o.from))} ${base}`;
        for (let b = lb0; b < nb; b++) lp += `L${x(o.from + b * BIN + BIN / 2).toFixed(1)} ${y(lka[b]).toFixed(1)}`;
        s += `<path d="${lp}L${xe} ${base}Z" fill="${C.leak}"/>`;
        let edge = ''; for (let b = lb0 + 1; b < nb; b++) edge += (edge ? 'L' : 'M') + x(o.from + b * BIN + BIN / 2).toFixed(1) + ' ' + y(lka[b]).toFixed(1);
        if (edge) s += `<path d="${edge}" fill="none" stroke="#B71C1C" stroke-width="1.5"/>`;
        s += lab(xe - 4, y(lka[nb - 1]) - 8, 'leak, never stops', '#B71C1C', 'end', 600);
      }
    }
    s += `<line x1="${m.l}" x2="${w - m.r}" y1="${base}" y2="${base}" stroke="${C.navy}"/>`;
    for (let d = Math.ceil(o.from / DAY); d * DAY <= o.to; d++) s += `<line x1="${x(d * DAY)}" x2="${x(d * DAY)}" y1="${base}" y2="${base + 5}" stroke="${C.muted}"/>`;
    for (let d = Math.floor(o.from / DAY); d * DAY < o.to; d++) { const c = Math.max(o.from, d * DAY), e = Math.min(o.to, (d + 1) * DAY); if (e - c >= DAY / 3) s += `<text x="${(x(c) + x(e)) / 2}" y="${h - 6}" font-size="12" fill="${C.navy}" text-anchor="middle">${DOW[dt(d * DAY).getUTCDay()]}</text>`; }
    s += lab(m.l, m.t - 12, 'Water use', C.navy, 'start', 600);
    if (st.notes) s += lab(m.l + 6, base - 10, M.t.floor ? 'normal overnight floor' : 'drops to zero overnight', C.navy, 'start');
    if (st.marker) { const lx = x(LEAK); s += `<line x1="${lx}" x2="${lx}" y1="${m.t}" y2="${base}" stroke="${C.leak}" stroke-width="1.5" stroke-dasharray="4 3"/>` + lab(lx - 6, m.t + 12, 'leak starts', C.leak, 'end', 600); }
    if (st.alert) { const ax = x(ALERT); s += `<line x1="${ax}" x2="${ax}" y1="${m.t}" y2="${base}" stroke="${C.deep}" stroke-width="2"/><circle cx="${ax}" cy="${m.t}" r="5" fill="${C.deep}"/>` + lab(ax + 9, m.t + 4, 'alert sent', C.deep, 'start', 600); }
    s += `<line class="xh" x1="0" x2="0" y1="${m.t}" y2="${base}" stroke="${C.navy}" visibility="hidden"/><rect class="hit" x="${m.l}" y="0" width="${iw}" height="${h}" fill="transparent"/>`;
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`); svg.setAttribute('height', h); svg.innerHTML = s;
    const xh = svg.querySelector('.xh'), hit = svg.querySelector('.hit');
    hit.onpointermove = e => {
      const b = Math.floor((e.clientX - svg.getBoundingClientRect().left - m.l) / iw * n / BIN);
      if (b < 0 || b >= nb) { tip.hidden = true; xh.setAttribute('visibility', 'hidden'); return; }
      const cx = x(o.from + b * BIN + BIN / 2); xh.setAttribute('x1', cx); xh.setAttribute('x2', cx); xh.setAttribute('visibility', 'visible');
      tip.hidden = false; tip.style.left = Math.min(Math.max(cx, 90), w - 90) + 'px'; tip.style.top = y(avg[b]) + 'px';
      tip.innerHTML = stamp(o.from + b * BIN) + '<br>' + avg[b].toFixed(1) + ' gal/min' + (st.leak && lka[b] ? `, leak ${lka[b].toFixed(1)}` : '');
    };
    hit.onpointerleave = () => { tip.hidden = true; xh.setAttribute('visibility', 'hidden'); };
  }
  watch(el, draw);
  return { load(m) { load(m); draw(); }, set(next) { st = { ...st, ...next }; draw(); } };
}

/* ---------- daily chart: one bar per day, leak share on top in red ---------- */
function dayChart(el, o) {
  const { svg, tip } = mount(el); let M = null;
  function draw() {
    const w = el.clientWidth; if (!w || !M) return;
    const h = mobile.matches ? 240 : 300, m = { t: 30, r: 8, b: 24, l: 8 };
    const iw = w - m.l - m.r, ih = h - m.t - m.b, base = m.t + ih, n = o.to - o.from, bw = iw / n, gap = bw > 4 ? 1.5 : bw > 2.5 ? 1 : 0;
    const max = Math.max(...M.daily.slice(o.from, o.to)) * 1.1;
    const X = d => m.l + (d - o.from) * bw, Y = v => base - v / max * ih, r = bw > 6 ? 2 : 0;
    let s = '';
    for (let d = o.from; d < o.to; d++) {
      const x0 = X(d) + gap / 2, bwi = bw - gap, tot = M.daily[d], lk = M.dailyLeak[d];
      s += `<path d="${roundTop(x0, base, bwi, Y(tot - lk), r)}" fill="${C.flow}"/>`;
      if (lk > 0) s += `<path d="${roundTop(x0, Y(tot - lk) - (gap ? 1 : 0), bwi, Y(tot), r)}" fill="${C.leak}"/>`;
    }
    s += `<line x1="${m.l}" x2="${w - m.r}" y1="${base}" y2="${base}" stroke="${C.navy}"/>`;
    [1, 2, 3].forEach(mo => { const d = dayOf(mo, 1); s += `<line x1="${X(d)}" x2="${X(d)}" y1="${base}" y2="${base + 5}" stroke="${C.muted}"/><text x="${X(d) + 4}" y="${h - 6}" font-size="12" fill="${C.navy}">${MONTH[mo]}</text>`; });
    const lx = X(Math.floor(LEAK / DAY));
    s += `<line x1="${lx}" x2="${lx}" y1="${m.t}" y2="${base}" stroke="${C.leak}" stroke-width="1.5" stroke-dasharray="4 3"/>` + lab(lx - 6, m.t + 12, 'leak starts', C.leak, 'end', 600);
    s += lab(m.l, m.t - 12, 'Water use per day', C.navy, 'start', 600);
    const last = o.to - 1, oneIn = Math.round(M.daily[last] / M.dailyLeak[last]);
    if (w > 420) s += lab(w - m.r, m.t - 12, `by late April, 1 in ${oneIn} gallons is the leak`, '#B71C1C', 'end', 600);
    s += `<rect class="hit" x="${m.l}" y="${m.t}" width="${iw}" height="${ih}" fill="transparent"/>`;
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`); svg.setAttribute('height', h); svg.innerHTML = s;
    const hit = svg.querySelector('.hit');
    hit.onpointermove = e => {
      const d = o.from + Math.floor((e.clientX - svg.getBoundingClientRect().left - m.l) / bw);
      if (d < o.from || d >= o.to) { tip.hidden = true; return; }
      tip.hidden = false; tip.style.left = Math.min(Math.max(X(d) + bw / 2, 90), w - 90) + 'px'; tip.style.top = Y(M.daily[d]) + 'px';
      tip.innerHTML = `${dlabel(d)}<br>${fmt(M.daily[d])} gal` + (M.dailyLeak[d] ? `<br>leak ${fmt(M.dailyLeak[d])} gal` : '');
    };
    hit.onpointerleave = () => { tip.hidden = true; };
  }
  watch(el, draw);
  return { load(m) { M = m; draw(); } };
}

/* ---------- bar chart (bills) ---------- */
function barChart(el) {
  const { svg, tip } = mount(el); let cfg = null;
  function draw() {
    const w = el.clientWidth; if (!w || !cfg) return;
    const h = mobile.matches ? 240 : 320, m = { t: 28, r: 10, b: 26, l: 48 };
    const iw = w - m.l - m.r, ih = h - m.t - m.b, n = cfg.bars.length, max = nice(Math.max(...cfg.bars.map(b => b.v)) * 1.08);
    const y = v => m.t + (1 - v / max) * ih, bw = iw / n, gap = Math.min(cfg.gap, bw * 0.3);
    let s = '';
    ticks(max).forEach(v => { s += `<line x1="${m.l}" x2="${w - m.r}" y1="${y(v)}" y2="${y(v)}" stroke="${C.rule}"/><text x="${m.l - 6}" y="${y(v) + 4}" font-size="11" fill="${C.muted}" text-anchor="end">${tfmt(v)}</text>`; });
    cfg.bars.forEach((b, i) => {
      const x0 = m.l + i * bw + gap / 2, bwi = bw - gap, lk = cfg.showLeak ? b.leak : 0, r = bwi > 8 ? 4 : bwi > 3 ? 1.5 : 0;
      s += `<path d="${roundTop(x0, y(0), bwi, y(b.v - lk), r)}" fill="${C.flow}"/>`;
      if (lk > 0) s += `<path d="${roundTop(x0, y(b.v - lk) - (bwi > 3 ? 1.5 : 0), bwi, y(b.v), r)}" fill="${C.leak}"/>`;
      if (b.label) s += `<text x="${x0 + bwi / 2}" y="${h - 7}" font-size="11" fill="${C.navy}" text-anchor="middle">${bw < 90 && b.short ? b.short : b.label}</text>`;
      if (cfg.values && bw >= 64) s += `<text x="${x0 + bwi / 2}" y="${y(b.v) - 8}" font-size="12" font-weight="500" fill="${C.navy}" text-anchor="middle">${tfmt(Math.round(b.v / 1000) * 1000)} gal</text>`;
      s += `<rect class="hb" data-i="${i}" x="${m.l + i * bw}" y="${m.t}" width="${bw}" height="${ih}" fill="transparent"/>`;
    });
    if (cfg.marker != null) { const mx = m.l + cfg.marker * bw; s += `<line x1="${mx}" x2="${mx}" y1="${m.t - 6}" y2="${y(0)}" stroke="${C.leak}" stroke-width="1.5" stroke-dasharray="4 3"/>` + lab(mx - 6, m.t - 10, 'leak starts Mar 4', C.leak, 'end', 600); }
    s += `<line x1="${m.l}" x2="${w - m.r}" y1="${y(0)}" y2="${y(0)}" stroke="${C.navy}"/>`;
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`); svg.setAttribute('height', h); svg.innerHTML = s;
    svg.querySelectorAll('.hb').forEach(r => {
      r.onpointerenter = () => { const b = cfg.bars[+r.dataset.i]; tip.hidden = false; tip.innerHTML = b.tip(cfg.showLeak); tip.style.left = Math.min(Math.max(+r.getAttribute('x') + bw / 2, 90), w - 90) + 'px'; tip.style.top = y(b.v) + 'px'; };
      r.onpointerleave = () => { tip.hidden = true; };
    });
  }
  watch(el, draw);
  return { set(c) { cfg = c; tip.hidden = true; draw(); } };
}

/* ---------- hero strip: normal use stacked on a leak that never stops ---------- */
(function strip() {
  const svg = $('#strip'), M = getModel('apartments'), from = mins(3, 21), to = mins(3, 26), LK = 10, LS = mins(3, 23, 2, 14);
  const data = []; for (let a = from; a < to; a += BIN) { let t = 0; for (let i = a; i < a + BIN; i++) t += M.flow(i) - M.leakAt(i) + (i >= LS ? LK : 0); data.push(t / BIN); }
  const ymax = Math.max(...data) * 1.04;
  function draw() {
    const w = svg.clientWidth, h = svg.clientHeight; if (!w || !h) return;
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    const n = data.length, base = h - 1, y = v => base - v / ymax * (h - 6);
    const line = data.map((v, k) => (k ? 'L' : 'M') + ((k + 0.5) / n * w).toFixed(1) + ' ' + y(v).toFixed(1)).join('');
    const ly = y(LK), lx = (LS - from) / (to - from) * w;
    svg.innerHTML = `<path d="${line}L${w} ${base}L0 ${base}Z" fill="${C.flow}" fill-opacity=".85"/><path d="${line}" fill="none" stroke="${C.flow}" stroke-width="2" stroke-linejoin="round"/>`
      + `<rect x="${lx}" y="${ly}" width="${w - lx}" height="${base - ly}" fill="${C.leak}"/>`
      + `<line x1="${lx}" x2="${w}" y1="${ly}" y2="${ly}" stroke="#B71C1C" stroke-width="1.5"/>`
      + `<line x1="0" x2="${w}" y1="${base + 0.5}" y2="${base + 0.5}" stroke="${C.navy}"/>`
      + lab(lx + 4, ly - 9, w > 480 ? `leak starts, ${LK} gal/min, never stops` : 'leak starts', '#B71C1C', 'start', 600);
  }
  new ResizeObserver(draw).observe(svg); draw();
})();
if (!reduce) $$('[data-count]').forEach(el => {
  const end = +el.dataset.count, pre = el.dataset.prefix || '', t0 = performance.now();
  const tick = now => { const p = Math.min(1, (now - t0) / 1400), e = 1 - (1 - p) ** 4; el.textContent = pre + fmt(end * e); if (p < 1) requestAnimationFrame(tick); };
  requestAnimationFrame(tick);
});

/* ---------- story ---------- */
const storyMin = flowChart($('#storyMinute'), { id: 'sm', from: mins(2, 3), to: mins(2, 5, 12) });
const storyDay = dayChart($('#storyDay'), { from: dayOf(1, 1), to: LEAK_END_DAY + 1 });
const STATES = [
  { until: mins(2, 4, 2), leak: false, marker: false, alert: false, notes: true },
  { until: mins(2, 5, 2), leak: true, marker: true, alert: false, notes: true },
  { until: mins(2, 5, 12), leak: true, marker: true, alert: true, notes: true },
  null,
];
let type = 'apartments', M = getModel(type), cur = -1, lock = 0;
const stepsEl = $('#steps'), alertsEl = $('#alerts');
function renderSteps() {
  const t = M.t, gpd0 = t.leak0 * DAY;
  const caught = M.leakGal(LEAK, mins(2, 5, 17)), missed = M.leakGal(LEAK, mins(4, 8));
  const S = [
    ['TUESDAY', t.s0h, t.s0p, ''],
    ['WEDNESDAY, 2:14 AM', t.cause, `${t.floor ? 'From here on, the overnight floor sits higher than normal.' : `From here on, the ${t.quiet} flow never drops to zero.`} The red is water going down the drain around the clock, about ${fmt(r100(gpd0))} gallons a day.`, 'leakstep'],
    ['THURSDAY, 2:14 AM', 'NOWi sends an alert.', `After 24 hours of water running without a break, ${t.who.toLowerCase()} gets a text and an email with the size of the leak and when it started.`, ''],
    ['THE NEXT EIGHT WEEKS', 'Left alone, small leaks grow.', `Each week wastes a little more, but the bill only creeps up. A few percent a month is easy to explain away: ${t.explain}.`, 'leakstep'],
  ];
  stepsEl.innerHTML = S.map(([when, h, p, cls], i) => `<article class="step ${cls}" data-step="${i}"><p class="when">${when}</p><h3>${h}</h3><p>${p}</p>${i === 3 ? `<div class="cost">
    <span>Fixed after the alert</span><b class="num">${fmt(r100(caught))} gal</b>
    <span class="bad">Found on the April bill</span><b class="num bad">${fmt(r100(missed))} gal, ${money(missed * RATE)}</b></div>` : ''}</article>`).join('');
}
function alertHtml() {
  const t = M.t, gpd0 = t.leak0 * DAY;
  return `<div class="notif hiw-pop"><div class="app"><span>NOWi</span><span>Thu 2:14 AM</span></div><b>Leak alert: ${t.alertName}</b><span>Water has run nonstop for 24 hours, about ${fmt(r100(gpd0))} extra gallons a day. Started Wednesday at 2:14 AM.</span></div>`;
}
function setStep(k, force) {
  if (k === cur && !force) return;
  const prev = cur; cur = k;
  $$('.step').forEach(s => s.classList.toggle('on', +s.dataset.step === k));
  $$('.chip').forEach(c => c.setAttribute('aria-pressed', String(+c.dataset.go === k)));
  const day = k === 3;
  $('#storyMinute').hidden = day; $('#storyDay').hidden = !day;
  if (!day) storyMin.set(STATES[k]);
  $('#storyScale').textContent = day ? 'February to April' : 'One week in March';
  if (k === 2) { if (prev !== 2 || force) alertsEl.innerHTML = alertHtml(); }
  else alertsEl.innerHTML = `<div class="hiw-empty">${k === 0 ? 'No alerts. Everything looks normal.' : k === 1 ? 'Watching. NOWi alerts once water has run nonstop for 24 hours.' : 'Alert sent Thursday. Nobody fixed it, so the leak keeps growing.'}</div>`;
}
function pick() { const line = innerHeight * 0.62; let k = 0; $$('.step').forEach((s, i) => { if (s.querySelector('h3').getBoundingClientRect().top < line) k = i; }); return k; }
let ticking = false;
addEventListener('scroll', () => {
  if (ticking || mobile.matches || Date.now() < lock) return;
  ticking = true; requestAnimationFrame(() => { ticking = false; setStep(pick()); });
}, { passive: true });
$$('.chip').forEach(c => c.addEventListener('click', () => {
  const k = +c.dataset.go; setStep(k);
  if (mobile.matches) return;
  lock = Date.now() + 1000;
  const top = $(`.step[data-step="${k}"] .when`).getBoundingClientRect().top + scrollY - innerHeight * 0.3;
  scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
}));
mobile.addEventListener('change', () => setStep(mobile.matches ? cur : pick(), true));

/* ---------- bills: would you know? ---------- */
const bars = barChart($('#resBars'));
let resLine = null, revealed = false, answered = null, mode = 'monthly';
const sum = (a, x, y) => a.slice(x, y).reduce((p, c) => p + c, 0);
const months = () => [...M.prior.map(p => ({ ...p, leak: 0 })), ...[[0, 31], [31, 59], [59, 90], [90, 120]].map(([a, b], i) => ({ name: MONTH[i], short: MON[i], v: sum(M.daily, a, b), leak: sum(M.dailyLeak, a, b) }))];
const MODES = {
  monthly() {
    const B = months();
    bars.set({ gap: 32, values: true, showLeak: revealed, bars: B.map(b => ({ label: b.name, short: b.short, v: b.v, leak: b.leak, tip: on => `${b.name} bill<br>${fmt(b.v)} gal` + (on && b.leak ? `<br>leak ${fmt(b.leak)} gal` : '') })) });
    return ['Monthly water bill', 'Gallons per billing period', 'On the bill, the leak is just a little more each month. The red tops show how much of each bill it was.'];
  },
  daily() {
    const a = dayOf(1, 1), b = dayOf(4, 8), list = [];
    for (let d = a; d < b; d++) { const dd = dt(d * DAY); list.push({ v: M.daily[d], leak: M.dailyLeak[d], label: dd.getUTCDate() === 1 ? MON[dd.getUTCMonth()] + ' 1' : '', tip: on => `${dlabel(d)}<br>${fmt(M.daily[d])} gal` + (on && M.dailyLeak[d] ? `<br>leak ${fmt(M.dailyLeak[d])} gal` : '') }); }
    bars.set({ gap: 2, values: false, showLeak: true, bars: list, marker: Math.floor(LEAK / DAY) - a });
    return ['Daily totals', 'Gallons per day, Feb 1 to May 7', 'Daily totals creep up a little each week. No single day stands out. The red tops are the leak.'];
  },
  minute() {
    if (!resLine) resLine = flowChart($('#resLine'), { id: 'rl', from: mins(2, 3), to: mins(2, 6, 12) });
    resLine.load(M); resLine.set({ leak: true, marker: true, alert: true, notes: true });
    return ['NOWi usage graph', 'Tuesday to Friday, March 3 to 6', 'In NOWi data the leak shows up the first night, and the alert went out 24 hours later. That is eight weeks before the bill would show it.'];
  },
};
function setRes(m) {
  mode = m;
  $$('#resSeg button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.res === m)));
  $('#resBars').hidden = m === 'minute'; $('#resLine').hidden = m !== 'minute';
  const [t, u, cap] = MODES[m]();
  $('#resTitle').textContent = t; $('#resUnit').textContent = u; $('#resCaption').textContent = cap;
}
$$('#resSeg button').forEach(b => b.addEventListener('click', () => { setRes(b.dataset.res); $('#resMinute').classList.remove('nudge'); }));
function renderAnswer() {
  if (answered === null) return;
  const B = months(), hi = Math.max(B[0].v, B[1].v, B[2].v), p = Math.round((B[5].v / hi - 1) * 100);
  const lead = answered ? 'Good eye, there is one.' : 'Most people say no. <b>There is a leak.</b>';
  const cmp = p <= 0 ? 'April came in no higher than the busiest month before the leak' : `April came in only ${p}% above the busiest month before the leak`;
  $('#qAnswer').innerHTML = `${lead} It started on March 4 and has grown every week since. ${cmp}. Bills swing that much on their own, so it is easy to put down to ${M.t.explain}.`;
}
function answer(yes) {
  revealed = true; answered = yes;
  $('#qYes').setAttribute('aria-pressed', String(yes)); $('#qNo').setAttribute('aria-pressed', String(!yes));
  renderAnswer(); $('#qAnswer').hidden = false; $('#seeit').hidden = false; setRes(mode);
}
$('#qYes').addEventListener('click', () => answer(true));
$('#qNo').addEventListener('click', () => answer(false));

/* ---------- estimator ---------- */
function estimate() {
  const u = Math.max(0, +$('#units').value || 0), gpd = Math.max(0, +$('#gpd').value || 0), rate = Math.max(0, +$('#rate').value || 0), share = +$('#share').value;
  $('#shareOut').textContent = share + '%';
  const gal = u * gpd * 365 * share / 100, usd = gal / 1000 * rate;
  $('#outDollars').innerHTML = money(usd) + '<small> a year</small>';
  $('#outGal').textContent = fmt(gal); $('#outMonth').textContent = money(usd / 12);
}
$('#estForm').addEventListener('input', estimate);
$('#estForm').addEventListener('submit', e => e.preventDefault());

/* ---------- property type: drives story, bills and estimator together ---------- */
function setType(k) {
  type = k; M = getModel(k);
  $$('.typeseg button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.type === k)));
  $('#storyMeter').textContent = M.t.meter;
  $('#billLede').textContent = `These are ${M.t.poss} water bills for November through April. Take a look, then answer.`;
  renderSteps(); storyMin.load(M); storyDay.load(M); setStep(mobile.matches ? Math.max(cur, 0) : pick(), true);
  if (resLine) resLine.load(M);
  setRes(mode); renderAnswer();
  const e = M.t.est;
  $('#lblCount').textContent = e.count; $('#units').value = e.n;
  $('#lblPer').textContent = e.per; $('#gpd').value = e.perN; $('#hintPer').textContent = e.perHint;
  $('#share').value = e.share; $('#hintShare').textContent = e.shareHint;
  estimate();
}
$$('.typeseg button').forEach(b => b.addEventListener('click', () => setType(b.dataset.type)));
setType('apartments');
})();
